import queryString from 'query-string';

export function createQueryParamsFromLocation(): Record<
  string,
  string | undefined
> {
  const parsedParams = queryString.parse(location.search);

  const params: Record<string, string> = {};

  for (const [key, value] of Object.entries(parsedParams)) {
    if (Array.isArray(value)) {
      params[key] = value[0];
    } else if (value) {
      params[key] = value;
    }
  }

  return params;
}
